import styled from 'styled-components'

import Gap from '@/common/components/Gap'

import { MAP_DESKTOP_HEIGHT } from '../NearbyPlacesMap/styled'

export const DetailWrapper = styled(Gap).attrs({
  space: 12,
  vertical: true,
})`
  height: ${MAP_DESKTOP_HEIGHT}px;
  width: 350px;
`
